import React, { Component } from 'react';
import '../App.css';

import { FaApple } from 'react-icons/fa';
import { FaGooglePlay } from 'react-icons/fa';
import { FaCode } from 'react-icons/fa';

// Third Party 
import AOS from 'aos';
import 'aos/dist/aos.css';

class SingleAppShowcase extends Component {

  componentDidMount() {
    AOS.init({
      duration : 500
    })
  }

  render() {
    return (
        <div
          style={{backgroundColor: this.props.backgroundColor}}
          className={"project-showcase-wrapper " + this.props.addClass}
        >
          <div 
            className="row"
            style={{
              flexDirection: this.props.mirrored ? "row-reverse" : "row",
            }}
          >
            <div
              className="col-xs-12 col-sm-6 bg-test-1 app-container"
            >
              <img 
                src={this.props.appVisual}                
                style={{
                  width: '135%', 
                  padding: this.props.extraPadding,
                }}
                alt={""}
                data-aos= {this.props.mirrored ? "fade-left" : "fade-right" }
              />
            </div>
            <div
              className="col-xs-12 col-sm-6 bg-test-2 app-container"
            >
              <div
                className="col"
              >
                {this.props.appLogo &&
                  <img 
                    src={this.props.appLogo} 
                    alt="" 
                    className="mb-2"
                    style={{
                      width: this.props.logoWidth ? this.props.logoWidth : '100%'
                    }}
                    data-aos="fade"
                  />
                }
                {this.props.appTitle &&
                  <h2 style={{
                    color: this.props.lightText ? "#FFF" : "#000",
                    fontWeight: 'bold',
                    fontFamily: "Inter",
                    fontSize: '38px',
                    letterSpacing: '1.6px'
                  }}
                  data-aos="fade"
                  >
                    {this.props.appTitle}</h2>
                }
                <p style={
                  {color: this.props.lightText ? "#FFF" : "#000", fontSize: '16px', fontFamily: 'Inter', padding: '16px'}}>
                  {this.props.appDescription}
                </p>

                <p style={{color: this.props.lightText ? "#FFF" : "#000"}}>
                  {this.props.contribution}
                </p>
                <div class="row d-flex justify-content-center">
                  { this.props.appStoreLink && 
                  <a href={this.props.appStoreLink} target="_blank" className="btn btn-dark mr-2">
                     <FaApple/> App Store
                  </a>
                  }
                  { this.props.googlePlayLink && 
                  <a  href={this.props.googlePlayLink} target="_blank" className="btn btn-dark mr-2">
                     <FaGooglePlay/> Google Play Store
                  </a>
                  }
                  {this.props.url &&
                  <a  href={this.props.url} target="_blank" className="btn btn-light mr-2">
                     <FaCode/> Visit Site
                  </a>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      
    );
  }
}

export default SingleAppShowcase;



// WEBPACK FOOTER //
// ./src/components/SingleAppShowcase.js